<template>
  <div class="rule-manage-box">
    <div class="title">规则管理</div>
    <div class="manage-msg" @click="handleClick(item)" :class="selectBtn == item.target ? 'select' : ''" v-for="(item,index) in list" :key="index">
      {{item.title}}
    </div>

  </div>
</template>

<script lang="ts">
import { defineComponent, ref, PropType, toRefs } from 'vue'
import type{ IndexEchart } from '@/types/index'
export default defineComponent({
  props: {
    listData: {
      type: Array as PropType<IndexEchart.RuleManageList[]>
    }
  },
  components: {},
  setup(props, { emit }) {
    const list = toRefs(props).listData

    const selectBtn = ref<string>()
    if (list.value && list.value.length > 0) {
      emit('selectTag', list.value[0])
      selectBtn.value = list.value[0].target
    }
    const handleClick = (data:IndexEchart.RuleManageList) => {
      selectBtn.value = data.target
      emit('selectTag', data)
    }

    return {
      selectBtn,
      list,
      handleClick
    }
  }
})
</script>
<style lang="scss" scoped>
.rule-manage-box {
  padding: 16px;
  .title {
    font-weight: 500;
    font-size: 16px;
    color: #132043;
    padding-left: 8px;
    position: relative;
    margin-bottom: 12px;
  }
  .title::after {
    width: 2px;
    height: 20px;
    background-color: #1d4cd2;
    position: absolute;
    left: 0;
    top: 3px;
    content: '';
  }

  .manage-msg {
    width: 100%;
    height: 36px;
    border-bottom: 1px solid rgb(235, 239, 241);
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    padding-left: 8px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    cursor: pointer;
    transition: 0.5s background-color ease;
    border-radius: 4px 0px 0px 4px;
    overflow: hidden;
  }
  .select {
    background: #1d4cd2;
    border-radius: 4px 0px 0px 4px;
    border-bottom: 1px solid rgb(235, 239, 241);
    color: #fff;
    overflow: hidden;

  }
}
</style>
